module.exports = __webpack_public_path__ + "static/media/Minnesota Beef Council Logo.04e354dd.png";